import React from 'react';
import cn from 'classnames';

export default ({ className, style }) => (
  <hr className={cn({ 'mui-divider': true, [className]: className })} style={style} />
);
